// extracted by mini-css-extract-plugin
export var searchHeader = "_b4-0";
export var searchHeaderDark = "_b4-1";